<template>
  <div class="main">
    <!-- banner -->
    <div class="banner">
      <div class="slider">
        <div class="item" v-for="(item, index) in isMobile ? bannerData2 : bannerData" :key="item.id">
          <a class="con">
            <div class="bg" :style="{ 'background-image': 'url(' + item.carouselBackUrl + ')' }" :class="{ 'loaded': imageLoaded[index] }"></div>
            <!-- <div class="cont cont-2">
              <div class="pic pic2">
                <img :src="item.carouselImg" alt="">
              </div>
              <div class="txt txt2">
                <div class="tit2">
                  <em></em>
                  <h3>{{ item.carouselName }}</h3>
                </div>
                <div class="desc">
                  {{ item.carouselDesc }}
                </div>
              </div>
            </div> -->
          </a>
        </div>
      </div>
      <ul class="case_slick3_dots">
        <li v-for="(item, index) in bannerData" :key="item.id" :class="{ 'base': index === 0 }">
          <div class="numb">
            <i></i>
          </div>
          <div class="wrapper">
            <div class="circle left"></div>
            <div class="circle right"></div>
          </div>
        </li>
      </ul>
    </div>
    <!-- banner-end -->
    <!-- 内容 -->
    <!-- 产品 -->
     
    <div class="row-a1  is-show-product-pc"  style="position: relative;height: 30vw;">
      <div class="g-t1 wow fadeInUp dis-title" data-wow-duration="1.5s" data-wow-delay="0.2s"
        style="z-index: 10000;position: absolute;top: 0;left: 0;right: 0; margin: 0 auto;">
        <em>product</em>
        <h2 style="color: #fff;">产品中心</h2>
      </div>
      <div class="m-slider1 wow fadeInUp mob-product"
        style="word-wrap: nowrap;display: flex;justify-content: space-between;" data-wow-duration="1.5s"
        data-wow-delay="0.3s">
        <div v-for="(item, index) in productData" :key="index" class="product-item" @click="$router.push('/product-center?id=' + item.id)">
          <div class="product-img-container">
            <img :src="item.image2" alt="" class="i-on">
            <img :src="item.image2" alt="" class="i-ok">
          </div>
          <div>
            <h3>{{ item.name }}</h3>
            <p>{{ item.desc }}</p>
            <div class="line">
              <div></div>
            </div>
          </div>
          <div class="product-btn-detail" >
            <div>查看详情</div>
            <div>→</div>

          </div>
        </div>
      </div>
    </div>

    <div class="row-a1  is-show-product-phone" style="background-image: none; ">
      <div class="g-t1 wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">
        <em>product</em>
        <h2 style="color: #222;">产品中心</h2>
      </div>
      <div class="m-slider1 wow fadeInUp mob-product"
         data-wow-duration="1.5s"
        data-wow-delay="0.3s">
        <div v-for="(item, index) in productData" :key="index" class="product-item" @click="$router.push('/product-center?type=mobile&id=' + item.id)">
          <div class="product-img-container">
            <img :src="item.image" alt="" class="i-on">
            <img :src="item.image2" alt="" class="i-ok">
          </div>
          <div>
            <h3>{{ item.name }}</h3>
            <p>{{ item.desc }}</p>
            <div class="line">
              <div></div>
            </div>
          </div>
          <div class="product-btn-detail" >
            <div>查看详情</div>
            <div>→</div>

          </div>
        </div>
      </div>
    </div>
    <!-- 技术文档 -->
    <div class="" style="position: relative;">
        <div class="g-t1 wow fadeInUp ishowUING" data-wow-duration="1.5s" data-wow-delay="0.2s"
        style="z-index: 10000;position: absolute;top: 0;left: 0;right: 0; margin: 0 auto;">
        <em>DOCUMENT</em>
        <h2 style="color: #fff;">应用中心</h2>
      </div>
      <div >
        
        <!-- <div >
          <em>document</em>
          <h2>资源中心</h2>
        </div> -->
        <div class="app-center">
          <div class="app-item-1 wow fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.2s">
           <div class="app-item-inner" @click="$router.push('/app-center?id=18')">
             <div class="app-item-title">通信解决方案</div>
            <div class="app-item-tips">Communication soluti</div>
            <div class="app-item-line"></div>
            <div class="app-item-desc">暂无描述</div>
              <div class="app-item-more" >
                <div >查看详情</div>
                  <div style="color: #333;">→</div>
              </div>
           </div>

          </div>
          <div class="app-item-2 wow fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.4s">
             <div class="app-item-inner" @click="$router.push('/app-center?id=19')">
             <div class="app-item-title">雷达解决方案</div>
            <div class="app-item-tips">Radar solutions</div>
            <div class="app-item-line"></div>
            <div class="app-item-desc">暂无描述</div>
                <div class="app-item-more" @click="$router.push('/app-center?id=19')">
                <div >查看详情</div>
                  <div style="color: #333;">→</div>
              </div>
           </div>
          </div>
          <div class="app-item-3 wow fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.6s">
           <div class="app-item-inner" @click="$router.push('/app-center?id=20')">
             <div class="app-item-title">测试解决方案</div>
            <div class="app-item-tips">Test solutions</div>
            <div class="app-item-line"></div>
            <div class="app-item-desc typing-demo">
              <div>包括各种规格的微波器件和天线，有超强的系统配</div>
              <div>套和组合能力，能为客户提供整体方案</div>
              </div>
              <div class="app-item-more" @click="$router.push('/app-center?id=20')">
                <div >查看详情</div>
                  <div style="color: #333;">→</div>
              </div>
           </div>
          </div>
          <div class="app-item-4 wow fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.8s">
           <div class="app-item-inner" @click="$router.push('/app-center?id=21')">
             <div class="app-item-title">其他解决方案</div>
            <div class="app-item-tips">Other solutions</div>
            <div class="app-item-line"></div>
            <div class="app-item-desc">暂无描述</div>
            <div class="app-item-more" @click="$router.push('/app-center?id=21')">
              <div >查看详情</div>
                <div style="color: #333;">→</div>
            </div>
           </div>
          </div>
        </div>
 
      </div>
    </div>
    <!-- 底部分类 -->
    <div class="table-list">
          <div class="table-list-item" v-for="(item, index) in tablesListData" @click="$router.push(item.url)" :key="index" >
              <img :src="item.backgroundImg" alt=""></img>
              <div class="table-list-item-title">{{item.title}}</div>
              <div class="table-list-item-desc">{{item.desc}}</div>
          </div>
    </div>
   
  </div>
</template>

<script>
import RequestUtil from '../utils/request';

export default {
  name: 'Home',
  data() {
    return {
      // carouselData: [],
      bannerData: [
        { id: 1, carouselBackUrl: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/e8342d71-1230-4c3c-9fe8-da45dd590a2f.png', carouselImg: '/images/banner/pc/1.png', carouselName: 'Communication solutions', carouselDesc: '我是描述' },
        { id: 2, carouselBackUrl: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/d7fc1b3c-361e-493e-95ac-5df25a77128d.png', carouselImg: '/images/banner/pc/2.png', carouselName: 'Radar solutions', carouselDesc: '我是描述' },
        { id: 3, carouselBackUrl: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/1e6947a6-2fee-4242-9c66-2ac7b131c1c9.png', carouselImg: '/images/banner/pc/3.png', carouselName: 'Test solutions', carouselDesc: '我是描述' },
        { id: 4, carouselBackUrl: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/119992d1-7aa6-41a3-b3b9-2454480fd8e3.png', carouselImg: '/images/banner/pc/4.png', carouselName: 'Other solutions', carouselDesc: '我是描述' },
      ],
          bannerData2: [
        { id: 1, carouselBackUrl: '/images/banner/phone/1.png', carouselImg: '/images/banner/phone/1.png', carouselName: 'Communication solutions', carouselDesc: '我是描述' },
        { id: 2, carouselBackUrl: '/images/banner/phone/2.png', carouselImg: '/images/banner/phone/2.png', carouselName: 'Radar solutions', carouselDesc: '我是描述' },
        { id: 3, carouselBackUrl: '/images/banner/phone/3.png', carouselImg: '/images/banner/phone/3.png', carouselName: 'Test solutions', carouselDesc: '我是描述' },
        { id: 4, carouselBackUrl: '/images/banner/phone/4.png', carouselImg: '/images/banner/phone/4.png', carouselName: 'Other solutions', carouselDesc: '我是描述' },
      ],
      productData: [
        { id: 308, name: '波导器件', image2: '/images/i-a1.png', image: '/images/i-a1-on.png', desc: 'Waveguide Devices' },
        { id: 111, name: '天线', image2: '/images/i-a5.png', image: '/images/i-a5-on.png', desc: 'Antenna' },
        { id: 16, name: '同轴器件', image2: '/images/i-a2.png', image: '/images/i-a2-on.png', desc: 'Coaxial Devices' },
        { id: 759, name: '电缆及电缆组件', image2: '/images/i-a3.png', image: '/images/i-a3-on.png', desc: 'Cables And Cable Ass' },
        { id: 1, name: '其他微波器件', image2: '/images/i-a4.png', image: '/images/i-a4-on.png', desc: 'Other microwave devi' },

      ],
       appCenterData: [
        { id: 18, name: '通信解决方案', phoneImg: '/images/appCenter/1.png', pcImg: '/images/appCenter/1.png', tips: 'Communication soluti',desc:'' },
        { id: 19, name: '雷达解决方案', phoneImg: '/images/appCenter/2.png', pcImg: '/images/appCenter/2.png', tips: 'Radar solutions',desc:'' },
        { id: 20, name: '测试解决方案', phoneImg: '/images/appCenter/3.png', pcImg: '/images/appCenter/3.png', tips: 'Test solutions',desc:'包括各种规格的微波器件和天线，有超强的系' },
        { id: 21, name: '其他解决方案', phoneImg: '/images/appCenter/4.png', pcImg: '/images/appCenter/4.png', tips: 'Other solutions',desc:'' },

      ],
      tablesListData: [
        { id: 1, url: '/about#company', title: '关于我们', backgroundImg: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/7563462c-addb-4258-abbd-0d20f3f5eacf.png', desc:'北京西宝电子技术有限责任公司是从事微波毫米波产品研发和生产的高科技公司' },
        { id: 2, url: '/about#honors', title: '公司荣耀', backgroundImg: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/6ee706b2-b769-4ab5-ad7f-4756c9629126.png', desc:'公司于2003年通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进' },
        { id: 3, url: '/news', title: '新闻资讯', backgroundImg: 'https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/23ef3018-f9d8-4dd1-bd77-fff63f52b917.png', desc:'北京西宝电子诚邀您莅临第16届 中国国际微波及天线技术展览会' }
      ],
      imageLoaded: [false, false, false, false] // banner 图片加载状态
    };
  },
  async mounted() {
    // 预加载 banner 图片
    this.preloadBannerImages();
    
    // 获取轮播图数据
    await this.getCarouselData();

    // 数据加载完成后初始化轮播图
    this.$nextTick(() => {
      this.initSliders();
    });
  },
    computed: {
    isMobile() {
      // 检测是否为移动设备
      // 预渲染时默认使用 PC 端 (window.innerWidth 可能为 800 或不存在)
      if (typeof window === 'undefined') {
        return false;
      }
      return window.innerWidth <= 900;
    },
  },
  methods: {
    // 预加载 banner 图片
    preloadBannerImages() {
      const images = this.isMobile ? this.bannerData2 : this.bannerData;
      images.forEach((item, index) => {
        const img = new Image();
        img.onload = () => {
          this.$set(this.imageLoaded, index, true);
        };
        img.src = item.carouselBackUrl;
      });
    },
    // 销毁所有 slick 实例
    destroySliders() {
      if (window.$ && window.$.fn.slick) {
        // 销毁主轮播图
        if ($('.banner .slider').hasClass('slick-initialized')) {
          $('.banner .slider').slick('unslick');
        }
        // 销毁产品中心滑块
        if ($('.m-slider1 .slider-for').hasClass('slick-initialized')) {
          $('.m-slider1 .slider-for').slick('unslick');
        }
        if ($('.m-slider1 .slider-nav .slider').hasClass('slick-initialized')) {
          $('.m-slider1 .slider-nav .slider').slick('unslick');
        }
        // 销毁其他滑块
        if ($('.m-slider2 .slider').hasClass('slick-initialized')) {
          $('.m-slider2 .slider').slick('unslick');
        }
        if ($('.m-slider4 .slider').hasClass('slick-initialized')) {
          $('.m-slider4 .slider').slick('unslick');
        }
      }
    },
    // 清理轮播图相关事件监听器
    cleanupSliderEvents() {
      $(document).off('click', '.case_slick3_dots li');
    },
    async getCarouselData() {
      // this.bannerData = [];
      //   const response = await RequestUtil.get('/wx/carousel/listById?type=3');
      //   this.bannerData = response.data;
          // response.data.forEach(item => {
          //   this.bannerData.push(
          //           { 
          //             id: item.id, 
          //             type: 'left-image-right-text', 
          //             bgImage: item.carouselBackUrl, 
          //             title: null, 
          //             heading: null,
          //             content: {
          //               image: item.carouselImg,
          //               title: item.carouselName,
          //               label: null,
          //               description: item.carouselDesc
          //             }
          //           }
          //   );
          // });
          
          
    },
    initSliders() {
      // 先销毁已存在的 slick 实例（处理预渲染后的情况）
      this.destroySliders();
      
      // 清理预渲染留下的 slick 相关类名和样式，恢复原始 DOM 结构
      if ($('.banner .slider').hasClass('slick-initialized')) {
        $('.banner .slider').removeClass('slick-initialized slick-slider');
        $('.banner .slider .slick-list').children().unwrap().unwrap();
        $('.banner .slider .slick-slide').removeClass('slick-slide slick-current slick-active');
      }
      
      // 检查jQuery和Slick是否可用
      if (window.$ && window.$.fn.slick) {
        // 初始化主轮播图
        $('.banner .slider').slick({
          dots: false,
          arrows: false,
          autoplay: true,
          slidesToShow: 1,
          autoplaySpeed: 5000,
          pauseOnHover: false,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          lazyLoad: 'ondemand'
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $('.case_slick3_dots li').removeClass('base');
          $('.case_slick3_dots li').eq(nextSlide).addClass('base');
        });

        $('.banner .slider').slick('slickGoTo', 0);
        $('.banner .slider .slick-current').addClass('img_scale');

        $('.banner .slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $('.banner .slider .slick-current').removeClass('img_scale');
        });

        $('.banner .slider').on('afterChange', function (event, slick, currentSlide) {
          $('.banner .slider .slick-current').addClass('img_scale');
        });

        // 更新指示器点击事件，使用事件委托确保动态元素也能响应
        $(document).on('click', '.case_slick3_dots li', function () {
          var _num = $(this).index();
          $('.banner .slider').slick('slickGoTo', _num);
        });

        // 初始化产品中心滑块
        $('.m-slider1 .slider-nav .item').mouseenter(function () {
          $(this).trigger("click");
        });

        $('.m-slider1 .slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          fade: true,
          speed: 0,
          asNavFor: '.m-slider1 .slider-nav .slider'
        });

        $('.m-slider1 .slider-nav .slider').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: '.m-slider1 .slider-for',
          dots: false,
          speed: 0,
          arrows: true,
          infinite: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              }
            }
          ]
        });

        // 初始化其他滑块
        $('.m-slider2 .item').mouseenter(function () {
          $(this).addClass('slick-current').siblings('.item').removeClass('slick-current');
        });

        $('.m-slider2 .slider').slick({
          dots: false,
          arrows: true,
          autoplay: false,
          slidesToShow: 1,
          infinite: true,
          variableWidth: true,
          autoplaySpeed: 5000,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                variableWidth: false,
                slidesToShow: 2
              }
            }
          ]
        });

        $('.m-slider4 .slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }

      // 初始化Swiper滑块
      if (window.Swiper) {
        var win_w = document.body.clientWidth;
        if (win_w > 1200) {
          var modify = 0;
          var certifySwiper = new Swiper('.m-slider3 .swiper-container', {
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            slideToClickedSlide: true,
            loop: true,
            loopedSlides: 5,
            navigation: {
              nextEl: '.m-slider3 .swiper-next',
              prevEl: '.m-slider3 .swiper-prev',
            },
            on: {
              progress: function (progress) {
                for (i = 0; i < this.slides.length; i++) {
                  var slide = this.slides.eq(i);
                  var slideProgress = this.slides[i].progress;

                  if (Math.abs(slideProgress) > 1) {
                    modify = (Math.abs(slideProgress) - 1) * 0.4 + 1;
                  }
                  translate = slideProgress * modify * 290 + 'px';
                  scale = 1 - Math.abs(slideProgress) / 5;
                  zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                  slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                  slide.css('zIndex', zIndex);
                  slide.css('opacity', 1);
                  if (Math.abs(slideProgress) > 3) {
                    slide.css('opacity', 0);
                  }
                }
              },
              setTransition: function (transition) {
                for (var i = 0; i < this.slides.length; i++) {
                  var slide = this.slides.eq(i);
                  slide.transition(transition);
                }
              }
            }
          });
        } else {
          var mySwiper = new Swiper('.m-slider3 .swiper-container', {
            initialSlide: 2,
            loop: true,
            navigation: {
              nextEl: '.m-slider3 .swiper-next',
              prevEl: '.m-slider3 .swiper-prev',
            },
          });
        }
      }

      // 初始化WOW动画
      if (window.WOW) {
        if (!(/msie [6|7|8|9]/i.test(navigator.userAgent))) {
          // 检查是否已经初始化过WOW动画
          if (!window.wowInstance) {
            var wow = new WOW({
              boxClass: 'wow',
              animateClass: 'animated',
              offset: 30,
              mobile: true,  // 改为true以支持移动设备
              live: true
            });
            wow.init();
            window.wowInstance = wow; // 保存实例避免重复初始化
          } else {
            // 重新触发WOW动画检测
            window.wowInstance.sync();
          }
        }
      }
      
      // 为动态内容强制触发动画
      setTimeout(() => {
        const elements = document.querySelectorAll('.wow');
        elements.forEach(el => {
          el.style.visibility = 'visible';
          el.classList.add('animated');
        });
      }, 100);
    }
  },
  beforeDestroy() {
    // 组件销毁前清理事件监听器
    this.cleanupSliderEvents();
    // 销毁 slick 实例
    this.destroySliders();
  }
}
</script>

<style >
/* 使用全局CSS样式 */

/* banner 图片加载优化 */
.banner .bg {
  background-color: #f0f0f0; /* 占位背景色 */
  transition: opacity 0.3s ease;
  opacity: 0.8;
}

.banner .bg.loaded {
  opacity: 1;
}

/* 图片渲染优化 */
.banner .bg,
.app-item-1, .app-item-2, .app-item-3, .app-item-4 {
  will-change: transform;
  transform: translateZ(0); /* 开启硬件加速 */
  backface-visibility: hidden;
}

/* 轮播图指示器样式 */


@media only screen and (min-width: 768px) {
  
  .banner{
    height: 22vw;

  }
.banner .bg{
  height: 22vw;
}
  .is-show-product-phone {
    display: none;
   
  }
  .mob-product{
    
    /* margin-top: -8vw; */
  }
  .product-item {
        padding-top: 7vw;

    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    /* min-height: 200px; */
    align-items: center;
    flex-direction: column;
    text-align: center;
    color: #333;
    flex: 1;
    height: 30vw;
     /* overflow: hidden; */
    /* text-align: center; */
  }

  .line {
    display: flex;
    justify-content: center;
    text-align: center;

  }

  .line div {
    width: 2vw;
    padding-top: 0.3vw;
    color: #fff;
    border-bottom: 1px solid #fff;
  }



  .product-btn-detail {
    margin-top: 7vw;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5vw;
    font-weight: 500;
    font-size: 0.8vw;
    line-height: 0.8vw;
        color: #fff;

    padding: 0.4vw 0.8vw;
    border: 1px solid #fff;
    border-radius: 23px;
  }

  .product-btn-detail div:last-child {

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 3px;
    background: #fff;
    border-radius: 50%;
    color: #000;

  }
  .product-item h3 {

    font-weight: 500;
    font-size: 1.5vw;
    color: #fff;
  }
  .product-item p {
    font-weight: 500;
    font-size: 0.51vw;
        color: #fff;


  }

  .product-item img {
    width: 5vw;
  }

  .product-item:hover {
    color: #fff !important;
    cursor: pointer !important;
    background: linear-gradient(180deg, #54C0DB 0%, #1A80D5 100%) !important;
  }

  .product-item:hover .product-btn-detail {
    color: #fff;
    border-color: #fff;
  }

  .product-item:hover .line div {
    border-bottom: 1px solid #fff;

  }

  .product-item:hover .product-btn-detail div:last-child {
    background: #fff;
    color: #248BD6;
  }

  .product-img-container {
    position: relative;
    display: inline-block;
  }

  .product-img-container .i-on {
    display: block;
  }

  .product-img-container .i-ok {
    display: none;
  }

  .product-item:hover .product-img-container .i-on {
    display: none;
  }

  .product-item:hover .product-img-container .i-ok {
    display: block;
  }
}

@media only screen and (max-width: 768px) {
  .banner{
    height: 50vw;

  }
.banner .bg{
  height: 50vw;
}
  .line {
    display: flex;
    justify-content: center;
    text-align: center;

  }

  .line div {
    width: 10vw;
    padding-top: 1.3vw;
    color: #333333;
    border-bottom: 1px solid #333333;
  }
  .is-show-product-pc {
    display: none;
  }
  .is-show-product-phone{
    display: block;
  }
  .mob-product {
    padding: 0 5vw;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4vw;
    margin: 10vw 0;
   
  }
  .product-item{
    width: calc(100% / 2 - 4vw);
    text-align: center;
     box-shadow: 0px 2px 21px 0px rgba(0,24,52,0.07);
    border-radius: 6px;
    background-color: #fff;
    padding: 5vw 2vw;
  }
    .product-item h3 {

    /* font-weight: 500; */
    /* font-size: 1.5vw; */
  }
  .product-item p {
  
    font-weight: 400;
    font-size: 2vw;
    color: #999999;

  }
  .product-item:hover p {
  
    font-weight: 400;
    font-size: 2vw;
    color: #fff;

  }

  .product-item img {
    width: 15vw;
  }
  .product-btn-detail {
    margin: 0 4vw;
    margin-top: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2vw;
    font-weight: 500;
    font-size: 3vw;
    /* line-height: 2vw; */
    color: #999999;
    padding: 0.8vw 1vw;
    border: 1px solid #999999;
    border-radius: 23px;
    
  }

  .product-btn-detail div:last-child {

    display: flex;
    align-items: center;
    justify-content: center;

    width: 5vw;
    height: 5vw;
    background: #248BD6;
    border-radius: 50%;
    color: #fff;

  }

}












.product-item:hover {
  color: #fff !important;
  cursor: pointer !important;
  background: linear-gradient(180deg, #54C0DB 0%, #1A80D5 100%) !important;
}

.product-item:hover .product-btn-detail {
  color: #fff;
  border-color: #fff;
}

.product-item:hover .line div {
  border-bottom: 1px solid #fff !important;

}

.product-item:hover .product-btn-detail div:last-child {
  background: #fff;
  color: #248BD6;
}

.product-img-container {
  position: relative;
  display: inline-block;
}

.product-img-container .i-on {
  display: block;
}

.product-img-container .i-ok {
  display: none;
}

.product-item:hover .product-img-container .i-on {
  display: none;
}

.product-item:hover .product-img-container .i-ok {
  display: block;
}


/* 应用中心 */
@media only screen and (min-width: 768px) {
  .app-center {
    margin-top: 2vw;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    
  }
    .app-item-1{
        background-image: url('https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/e328632d-6047-406e-8429-d356010ca686.png');

    }
    .app-item-2{
        background-image: url('https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/c0f9242e-25c9-4bd2-a732-9f4616206ee7.png');
    }
    .app-item-3{
        background-image: url('https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/382c4993-4bd6-4c6e-83d1-2f0bf01b99dc.png');
        
    }
    .app-item-4{
        background-image: url('https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/5f1878ce-f5aa-43cb-afc6-e10a28fc2311.png');
    }
    /* 所有图片都有过渡效果 */
    .app-item-1, .app-item-2, .app-item-3, .app-item-4 {
        transition: width 1.2s ease;
        will-change: width;
    }
    
    /* 默认第一个图片宽度较大 */
    .app-item-3 {
        width: 73.472vw !important;
    }
    
    /* 其他图片默认宽度较小 */
    .app-item-2, .app-item-1, .app-item-4 {
        width: 25vw;
    }
    
    /* 鼠标悬停时的目标图片变为大宽度 */
    .app-item-1:hover {
        width: 73.472vw !important;
    }
    
    .app-item-2:hover {
        width: 73.472vw !important;
    }
    
    .app-item-3:hover {
        width: 73.472vw !important;
    }
    
    .app-item-4:hover {
        width: 73.472vw !important;
    }
    
    /* 鼠标悬停时其他图片恢复小宽度 */
    .app-center:hover .app-item-1:not(:hover) {
        width: 15vw !important;
    }
    
    .app-center:hover .app-item-2:not(:hover) {
        width: 15vw !important;
    }
    
    .app-center:hover .app-item-3:not(:hover) {
        width: 15vw !important;
    }
    
    .app-center:hover .app-item-4:not(:hover) {
        width: 15vw !important;
    }
    .app-item-4{
        background-image: url('https://xibao-obs.obs.cn-north-4.myhuaweicloud.com/5f1878ce-f5aa-43cb-afc6-e10a28fc2311.png'); 
    }
  .app-item-1, .app-item-2, .app-item-3, .app-item-4 {
    /* flex: 1; */
    width: 25vw;      /* 288 ÷ 1920 × 100 ≈ 15 */
    height: 35.42vw;  /* 680 ÷ 1920 × 100 ≈ 35.42 */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .app-item-inner{
      display: flex;
      height: 100%;
      /* margin-top: auto; */
      flex-direction: column;
      /* align-items: center; */
      /* justify-content: flex-end; */
      padding-left: 1.25vw;
      padding-top: 20vw;
      padding-bottom: 10vw;
      cursor: pointer;
      


    .app-item-line  {
      width: 3vw;
      margin: 0.6vw 0 0.75vw 0;
      color: #333333;
      border-bottom: 1px solid #fff;
    }
      .app-item-title{
          font-weight: 600;
          font-size: 1.25vw;
          color: #fff;
      }
      .app-item-tips{
          font-weight: 500;
          margin: 0.1vw 0 0.2vw 0;
          font-size: 0.52vw;
          color: #fff;
         
      }
      .app-item-desc{
          font-size: 0.93vw;
          font-weight: 600;
          color: #fff;
          display: none;
          /* display: inline-block; */
          /* padding-right: 30vw; */
          /* width: 25vw; */
      }
      .app-item-3 .app-item-desc{
          display: block;
      }
      .app-item-more{
          font-size: 0.93vw;
          font-weight: 500;
          color: #fff;
          border: 1px solid #fff;
          width: 7vw;
          padding: 0.28vw 0.625vw;
          border-radius: 1.198vw;
          display: flex;
          gap: 0.7vw;
          align-items: center;
                    margin-top: 4vw;
                    cursor: pointer;

      }
      .app-item-more div:last-child{
          color: #050404 !important;
          background-color: #fff;
          border-radius: 50%;
          /* padding: 3px; */
          /* padding: 3px;
          text-align: center; */
          display: inline-block;
          /* padding: 0.2vw; */
          width: 0.9vw;
          height: 0.9vw;
          padding: 0.5vw;
          display: flex;
          align-items: center;
          justify-content: center;  
      }
  }
  .app-item-inner:hover .app-item-desc{
    display: block;
  }
  .app-item-inner:not(:hover) .app-item-desc{
    display: none;
  }
}


@media only screen and (max-width: 768px) {
  .ishowUING{
    display: none;
  }
  .app-center {
    margin-top: 2vw;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    
  }
    .app-item-1{
        background-image: url('../../public/images/appCenter/1.1.png');

    }
    .app-item-2{
        background-image: url('../../public/images/appCenter/2.2.png');
    }
    .app-item-3{
        background-image: url('../../public/images/appCenter/3.3.png');
        
    }
    .app-item-4{
        background-image: url('../../public/images/appCenter/4.4.png');
    }
    /* 所有图片都有过渡效果 */
    .app-item-1, .app-item-2, .app-item-3, .app-item-4 {
        transition: width 1.2s ease;
        will-change: width;
    }
    
    /* 默认第一个图片宽度较大 */
    /* .app-item-3 {
        width: 33.472vw !important;
    } */
    
    /* 其他图片默认宽度较小 */
    .app-item-2, .app-item-1,.app-item-3, .app-item-4 {
        width: 25vw;
    }
    
    /* 鼠标悬停时的目标图片变为大宽度 */
    .app-item-1:hover {
        width: 50vw !important;
    }
    
    .app-item-2:hover {
        width: 50vw !important;
    }
    
    .app-item-3:hover {
        width: 50vw !important;
    }
    
    .app-item-4:hover {
        width: 50vw !important;
    }
    
    /* 鼠标悬停时其他图片恢复小宽度 */
    .app-center:hover .app-item-1:not(:hover) {
        width: 25vw !important;
    }
    
    .app-center:hover .app-item-2:not(:hover) {
        width: 25vw !important;
    }
    
    .app-center:hover .app-item-3:not(:hover) {
        width: 25vw !important;
    }
    
    .app-center:hover .app-item-4:not(:hover) {
        width: 25vw !important;
    }
    .app-item-4{
        background-image: url('../../public/images/appCenter/4.4.png');
    }
  .app-item-1, .app-item-2, .app-item-3, .app-item-4 {
    /* flex: 1; */
    width: 25vw;      /* 288 ÷ 1920 × 100 ≈ 15 */
    height: 105.38vw;  /* 680 ÷ 1920 × 100 ≈ 35.42 */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .app-item-inner{
      display: flex;
      height: 100%;
      /* margin-top: auto; */
      flex-direction: column;
      align-items: center;
      /* justify-content: center; */
      /* justify-content: flex-end; */
      /* padding-left: 1.25vw;
      padding-top: 20vw;
      padding-bottom: 10vw; */
      


    .app-item-line  {
      width: 3vw;
      margin: 0.6vw 0 0.75vw 0;
      color: #333333;
      border-bottom: 1px solid #fff;
      display: none;
    }
      .app-item-title{
          font-weight: 600;
          font-size: 5vw;
          color: #fff;
          writing-mode: vertical-lr; 
          text-orientation: upright;
          letter-spacing: 0.5vw;
          padding-top: 12vw;
      }
      .app-item-tips{
          font-weight: 500;
          margin: 0.1vw 0 0.2vw 0;
          font-size: 0.52vw;
          color: #fff;
                display: none;

         
      }
      .app-item-desc{
          font-size: 0.93vw;
          font-weight: 600;
          color: #fff;
          display: none;
          /* display: inline-block; */
          /* padding-right: 30vw; */
          /* width: 25vw; */
      }
      .app-item-3 .app-item-desc{
          display: block;
      }
      .app-item-more{
          /* font-size: 0.93vw;
          font-weight: 500;
          color: #fff;
          border: 1px solid #fff;
          width: 7vw;
          padding: 0.28vw 0.625vw;
          border-radius: 1.198vw;
          display: flex;
          gap: 0.7vw; */
          align-items: center;
                    margin-top: 18vw;
                    /* display: none; */

      }
      .app-item-more div:first-child{
        display: none;
      }
      .app-item-more div:last-child{
       
          color: #fff !important;
          /* background-color: #fff; */
          font-size: 5vw ;
          border-radius: 50%;
          /* padding: 3px; */
          /* padding: 3px;
          text-align: center; */
          display: inline-block;
                    border: 1px solid #fff;

          /* padding: 0.2vw; */
          width: 7vw;
          height: 7vw;
          padding: 0.5vw;
          display: flex;
          align-items: center;
          justify-content: center;  
      }
  }
  /* .app-item-inner:hover .app-item-desc{
    display: block;
  }
  .app-item-inner:not(:hover) .app-item-desc{
    display: none;
  } */
}

@media only screen and (min-width: 768px) {
  .table-list{
      display: flex;
      /* gap: 10px; */
      justify-content: space-between;
      color: #FFFFFF;
      margin: 1.2vw 0;
    }
    .table-list-item{
      width: calc(100% / 3 - 0.5vw);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 5vw;
      position: relative;
      cursor: pointer;

    }
    .table-list-item img{
        background-repeat: no-repeat;
	-o-background-size: cover;
	-ms-background-size: cover;
	-moz-background-size: cover;
	-webkit-background-size: cover;
	background-size: cover;
    }
    .table-list-item-title{
      position: absolute;
        color: #FFFFFF;
      font-size: 1.8vw;
      font-weight: 600;
      top: 4vw;

    }
    .table-list-item-desc{
      /* color: #666666; */
      position: absolute;
      top: 8vw;
      font-weight: 400;
      font-size: 1.2vw;
      padding: 0 3vw;
      font-style: normal;
      text-align: center;

    }
   
}
 @media only screen and (max-width: 768px){
      .table-list{
      display: flex;
      color: #FFFFFF;
 margin: 3vw 0;
      /* gap: 10px; */
      /* justify-content: space-between;
      color: #FFFFFF;
      */
    }
    .table-list-item{
      /* width: calc(100% / 3 - 1vw); */
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      /* gap: 5vw; */
      position: relative;

    }
    .table-list-item img{
      /* background-size: cover;
      no-repeat center; */
      height: 58vw;
  background-repeat: no-repeat;
	-o-background-size: cover;
	-ms-background-size: cover;
	-moz-background-size: cover;
	-webkit-background-size: cover;
	background-size: cover;
    }
    .table-list-item-title{
      position: absolute;
        color: #FFFFFF;
      font-size: 5vw;
      font-weight: 600;
      top: 4vw;

    }
    .table-list-item-desc{
      /* color: #666666; */
      position: absolute;
      top: 15vw;
      font-weight: 400;
      font-size: 3vw;
      padding: 0 2vw;
      font-style: normal;
      text-align: center;

    }
  
}

</style>